<template>
  <div class="container">
    <Head   :showLeftIcon="flag"  title="视频播放"></Head>
<!--    <div class="channel-info">-->
<!--      <div>-->
<!--        <img :src="logoUrl" alt class="channel-img" />-->
<!--        <span class="channel-name">{{ channelName }}</span>-->
<!--      </div>-->
<!--      <div  v-if="flag" @click="backToCourse" class="back-course">返回课程</div>-->
<!--    </div>-->
    <div class="video">
      <!-- 阿里云播放器 -->
      <div
        :id="playerId"
        class="prism-player"
        v-if="Number(videoSourceType) === 1"
      ></div>
      <!-- 阔知网播放器 -->
      <div
          class="prism-player"
        id="cloud-player"
        v-if="Number(videoSourceType) === 0"
      ></div>
      <div id="mse" v-if="Number(videoSourceType) === 2"></div>
    </div>
    <div class="introduce">
      <div class="item-des" v-if="currentGoodsEntity != null">
        <p>{{ catalogData.catalogName }}</p>
        <van-rate
            class="introduce_rate"
            :value="5"
            :size="19"
            color="#1779FF"
            void-icon="star"
            void-color="#eee"
        />
      </div>
      <div
          class="item-info"
          style="margin-top: 15px"
          v-if="currentGoodsEntity"
      >
        特约讲师：{{ currentGoodsEntity.teacherName }}
      </div>
      <div class="item-info" v-if="currentGoodsEntity">
<!--        <p>时长：{{ getDuration(currentGoodsEntity.catLength) }}</p>-->
        <p>3456 人已购</p>
        <p class="classCount">共{{ catalogData.classCount }}课时</p>
      </div>
    </div>
    <van-tabs v-model="videoPlayTabname">
      <van-tab name="a" title="课程目录">
<!--        <div class="item-box" v-if="catalogData.catalogName">-->
<!--          <div class="item-des">{{ catalogData.catalogName }}</div>-->
<!--        </div>-->
        <div style="padding: 20px 15px; background: #fff">
          <CourseVideoLink
            :detail-data="item1"
            :goodsId="goodsId"
            :isPlay="isPlay"
            :key="'kecheng' + index1"
            @click.native="PlayCourse(index1)"
            v-for="(item1, index1) in courseGoodsList"
          ></CourseVideoLink>
        </div>
      </van-tab>

      <van-tab name="b" title="课程简介">
        <div class="item-box">
          <div class="item-intro" v-if="currentGoodsEntity">
            {{ currentGoodsEntity.keywords }}。
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <div class="bottom-box" v-if="videoPlayTabname === 'a'">
      <div style="height: 60px"></div>
      <div class="van-hairline--top-bottom bottom-btn" style="position: fixed">
        <div
          @click="preVideo"
          class="van-ellipsis btn-item"
          v-if="
            !is_click_nextVideo &&
            !is_click_preVideo &&
            courseGoodsList.length > 0
          "
        >
          上一节
        </div>
        <div
          class="van-ellipsis btn-item"
          v-if="
            !(
              !is_click_nextVideo &&
              !is_click_preVideo &&
              courseGoodsList.length > 0
            )
          "
        >
          上一节
        </div>
        <div
          @click="nextVideo"
          class="van-ellipsis btn-item"
          v-if="
            !is_click_nextVideo &&
            !is_click_preVideo &&
            courseGoodsList.length > 0
          "
        >
          下一节
        </div>
        <div
          class="van-ellipsis btn-item"
          v-if="
            !(
              !is_click_nextVideo &&
              !is_click_preVideo &&
              courseGoodsList.length > 0
            )
          "
        >
          下一节
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Head from '@/components/h5/Head'
import CourseVideoLink from '@/components/h5/CourseVideoLink'
import * as CHANNEL_INFO_API from '@/api/ChannelAPI'
import * as COURSE_GOOD_API from '@/api/ChannelCourseAPI'
import * as dateUtil from '@/api/dateUtil'
import load from 'load-script'
import { Logout, debounce } from '@/utils/uni'

export default {
  name: "VideoPlay",
  data () {
    return {
      logoUrl: localStorage.getItem('logoUrl') || sessionStorage.getItem('logoUrl'),
      channelName: localStorage.getItem('channelName') || '',
      status: '',
      videoPlayTabname: 'a',
      directoryActive: '',
      goodsThumb: '',    //课程封面图片
      isPlay: '',         //播放器状态
      index: 0,           //当前播放视频索引
      progress: 0,        //提交数据的学习进度
      initProgresss: 0,   //数据库学习进度
      progressNow: 0,     //当前的实时学习进度
      keywords: '',       //页面显示的数据
      currentTime: 0,     //提交数据的学习时间(视频播放到的时间点)
      initCurrentTime: 0, //数据库学习时间
      currentTimeNow: 0,  //当前的实时学习时间
      timeOut: '',
      isAdd: false,        //是否提交学习进度
      courseId: '',       //当前播放的课程id
      catalogId: '',      //当前播放的章节id
      goodsId: '',        //当前播放的视频id
      resNo: '',          //阔知网视频编码
      player: '',         //播放器对象
      catLength: '',      //当前播放视频的时长
      playerId: 'aliplayer_' + Math.random().toString(36).substr(2),
      isShowThumb: true,  //封面是否显示
      videoSourceType: 0, //视频数据源，0-阔知网，1-阿里云
      waterMarkId: 0,    //水印id
      url: '',
      playTime: 0,        //播放器初始化播放时间点
      catalogData: {},    //当前目录章节的数据
      courseGoodsList: [],  //当前目录章节下的视频数据
      currentLearnGoodsId: 0, //最后一次学习的视频记录id
      currentGoodsEntity: {},
      videoToken: '',  //阔知网需要的播放token,服务端生成jwt加密算法
      courseName: '',
      name: '',
      courseList: [],
      imgUrl: '',
      currentTimes: 0,
      studyTime: 0,
      is_click: false,
      isImg: true,
      isIntruActive: true,
      isCageActive: false,
      findGoods: false,
      CatalogInfo: {},
      is_click_nextVideo: false,
      is_click_preVideo: false,
      goodType: '',
      isHeader: 0,
      courseData: '',
      flag: true,
      isRecommend: false
    };
  },
  components: {
    Head,
    CourseVideoLink
  },
  created () {
    //从课程详细 课时点击开始学习跳转此视频列表
    console.log('从课程详细 课时点击开始学习跳转此视频列表', this.$route.params)
    // 渠道商对接判断
    if (this.$route.query.gat_id && this.$route.query.token && this.$route.query.c_no && this.$route.query.cat_id ) {
      localStorage.setItem('shangke_token', this.$route.query.token)
      localStorage.setItem('c_no', this.$route.query.c_no)
      this.goodsId = this.$route.query.gat_id
      this.courseId = this.$route.query.cat_id
      this.flag=false;
      this.getCourseInfo()
      this.ChannelFindInfo()
      sessionStorage.setItem('isChannel', 'true')

    }else if (this.$route.params.voidData) {
      this.goodsId = this.$route.params.goodsId
      this.courseName = this.$route.params.courseName
      this.catalogId = this.$route.params.courseGood.catalogId
      this.currentGoodsEntity = this.$route.params.courseGood
      this.isRecommend = this.$route.params.isRecommend
      this.index = this.$route.params.index
      this.getCatalogData()
    } else {
      this.goodsId = JSON.parse(sessionStorage.getItem('videoPlayMobile')).goodsId
      this.courseName = JSON.parse(sessionStorage.getItem('videoPlayMobile')).courseName
      this.catalogId = JSON.parse(sessionStorage.getItem('videoPlayMobile')).courseGood.catalogId
      this.currentGoodsEntity = JSON.parse(sessionStorage.getItem('videoPlayMobile')).courseGood
      this.isRecommend = JSON.parse(sessionStorage.getItem('videoPlayMobile')).isRecommend
      this.index = JSON.parse(sessionStorage.getItem('videoPlayMobile')).index
      this.getCatalogData()
    }


  },
  mounted () {
    if (!this.logoUrl) {
      CHANNEL_INFO_API.ChannelFindInfo(null).then(res => {
        this.channelName = res.data.channelName
        this.logoUrl = res.data.logoUrl
        localStorage.setItem('channelName', this.channelName)
        localStorage.setItem('logoUrl', this.logoUrl)
      })
    }
  },
  destroyed () {
    this.AddLearnlod()
  },
  methods: {
     ChannelFindInfo () {
      CHANNEL_INFO_API.ChannelFindInfo(null).then(res => {
        this.channelName = res.data.channelName
        this.logoUrl = res.data.logoUrl
        localStorage.setItem('channelName', this.channelName)
        localStorage.setItem('logoUrl', this.logoUrl)
      })
    },
    goodsInfo () {
        let data = {
        goodsId: this.goodsId,
        courseId: this.courseId
      }
      COURSE_GOOD_API.CourseGoodsDetail(data).then(res => {
        this.courseGood = res.data
        this.catalogId = this.courseGood.catalogId
        this.currentGoodsEntity = this.courseGood
        this.getCatalogData()
      })
    },
    getCourseInfo () {
      let data = {
        courseId: this.courseId,
        tourist:  this.tourist
      }
      COURSE_GOOD_API.GetCourseInfo(data)
        .then(res => {
          if (Number(res.code) === 0) {
            this.courseData = res.data
            this.courseName = this.courseData.courseName
            if(this.courseData !=null ){
              if(this.courseData.isPay==null || this.courseData.isPay==0){
                this.isRecommend=true;
                this.$message.success('尚未购买此课程')
              }else if(this.courseData .isPay==1){
                this.isRecommend=false;
                this.goodsInfo()
              }

            }
          } else {
            console.log('err')
          }
        })
    },


    //时间转换
    getDuration (val) {
      if (val) {
        return dateUtil.getDuration(val)
      }
    },
    beforeDestroy () {
      this.AddLearnlod()
      this.currentTime = this.currentTimeNow
      this.progress = this.progressNow || 0
      if (isNaN(this.progress)) {
        this.progress = (this.currentTime / this.catLength).toFixed(2)
      }
      clearInterval(this.timeOut)
      this.currentTime = 0
      this.progress = 0
    },


    // 查询当前章节信息
    getCatalogData () {
      // 获取该课程信息
      let data = {
        catalogId: this.catalogId,
        tourist: this.isRecommend
      }
      // 获取menu数据
      COURSE_GOOD_API.catalogInfo(data)
        .then(res => {
          if (Number(res.code) === 0) {
            this.catalogData = res.data
            this.getCourseGoodsList()
          } else if (res.code === 401) {
            this.$message.error('登录失效，请重新登录')
            Logout()
            // this.$router.push({
            //   name: 'login'
            // })
          } else {
            this.catalogData = {}
            this.courseGoodsList = []
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    getCourseGoodsList () {
      // 获取该课程信息
      let data = {
        courseId: this.courseId,
        catalogId: this.catalogId,
        tourist: this.isRecommend
      }
      // 获取menu数据
      COURSE_GOOD_API.getCourseGoodsList(data)
        .then(res => {
          if (Number(res.code) === 0) {
            this.courseGoodsList = res.data
            if (res.data && this.courseGoodsList.length > 0) {
              for (let i = 0; i < this.courseGoodsList.length; i++) {
                const goodsEntity = this.courseGoodsList[i];
                if (goodsEntity.goodsId == this.goodsId) {
                  this.index = i;
                  if (!goodsEntity.kzwVideoNo) {
                    this.videoSourceType = 1
                  }
                  break
                }
                console.log('---------')
                console.log(this.videoSourceType)
              }
              this.PlayCourse(this.index)
            }
          } else if (res.code === 401) {
            this.$message.error('登录失效，请重新登录')
            // this.$router.push({
            //   name: 'login'
            // })
            Logout()
          } else {
            this.courseGoodsList = []
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 点击事件加载视频获取视频资源
    PlayCourse: debounce(function (index) {
      console.log('点击事件加载视频获取视频资源01', index)
      this.beforeDestroy()
      if (this.is_click) {
        return false;
      }
      this.is_click = true;
      setTimeout(() => {
        this.is_click = false;
      }, 1000);
      if (!this.isShowThumb) {
        this.isShowThumb = true
      }
      if (this.player) {
        if (Number(this.videoSourceType) === 0) {
          this.player && this.player.destory()
        } else if (Number(this.videoSourceType) === 2) {
          this.player && this.player.destroy()
        } else {
          this.player && this.player.dispose()
          clearInterval(this.timeOut)
        }
        this.isPlay = 4
      }
      this.index = index
      this.playTime = 0
      this.currentGoodsEntity = this.courseGoodsList[this.index]
      if (this.currentGoodsEntity.courseGoodsLearnLogEntity) {
        this.playTime = this.currentGoodsEntity.courseGoodsLearnLogEntity.playTime
        this.initCurrentTime = this.currentGoodsEntity.courseGoodsLearnLogEntity.playTime
        this.initProgresss = this.currentGoodsEntity.courseGoodsLearnLogEntity.progress
      }
      this.goodsId = this.currentGoodsEntity.goodsId
      this.catalogId = this.currentGoodsEntity.catalogId
      this.courseId = this.currentGoodsEntity.courseId
      this.goodsThumb = this.courseGoodsList[this.index].goodsThumb
      this.catLength = this.courseGoodsList[this.index].catLength
      this.initPlayer();
    }, 300),
    // 添加学习记录
    AddLearnlod () {
      if (!this.isRecommend) {
        console.log(this.currentGoodsEntity.courseGoodsLearnLogEntity,this.progress)
        if ((this.currentGoodsEntity.courseGoodsLearnLogEntity == null || Number(this.progress) >= Number(this.currentGoodsEntity.courseGoodsLearnLogEntity.progress)) && this.currentTime > 0 && this.progress > 0) {
          let data = {
            goodsId: this.goodsId,
            courseId: this.courseId,
            catalogId: this.catalogId,
            progress: this.progress,
            playTime: this.currentTime,
          }
          if (this.isAdd) {
            COURSE_GOOD_API.AddLearnlod(data)
              .then(res => {
                if (res) {
                  this.isAdd = false
                  console.log('添加成功', data)

                  if (this.courseGoodsList.length > 0) {
                    for (let i = 0; i < this.courseGoodsList.length; i++) {
                      if (data.goodsId == this.courseGoodsList[i].goodsId) {
                        this.courseGoodsList[i].courseGoodsLearnLogEntity = data
                      }
                    }
                  }
                }
              }).catch(err => {
                console.log(err)
              })
          }
          this.currentGoodsEntity.playTime = this.currentTime
        }
      }
    },
    //初始化阿里云播放器
    aliPlayer (url) {
      var that = this
      // 阿里播放器
      /* eslint-disable */
      console.log(that.playerId)
      that.player = new Aliplayer(
        {
          id: that.playerId,
          /* 指定多路清晰度流的地址的地址 */
          source: url,
          playsinline: true, // H5是否内置播放
          useH5Prism: true, // 强制H5播放器
          width: '100%',
          // cover: that.goodsThumb,
          height: '100%',
          autoplay: false,
          isLive: false
        },
        function (player) {
          that.timeOut = setInterval(() => {
            var totalTime = player.getDuration()
            var currentTimeTemp = player.getCurrentTime()
            var progressTemp = 0
            currentTimeTemp = parseInt(currentTimeTemp)
            progressTemp = (currentTimeTemp / totalTime).toFixed(2)
            that.currentTimeNow = currentTimeTemp
            that.progressNow = progressTemp
            if (player.getStatus() === 'pause') {
              that.isPlay = 1
              // console.log(currentTimeTemp)
              // console.log(that.initCurrentTime)
              // console.log(progressTemp)
              // console.log(that.initProgresss)
              if (currentTimeTemp > that.initCurrentTime && progressTemp > that.initProgresss) {
                that.currentTime = currentTimeTemp
                that.progress = progressTemp
                that.initCurrentTime = currentTimeTemp
                that.initProgresss = progressTemp
                that.isAdd = true
                that.AddLearnlod()
              }
            } else if (player.getStatus() === 'ended') {
              that.isPlay = 3
              if (currentTimeTemp > that.currentTime && progressTemp > that.progress) {
                that.currentTime = currentTimeTemp
                that.progress = progressTemp
                that.isAdd = true
                that.AddLearnlod()
                clearInterval(that.timeOut)
                that.progress = 0
                that.currentTime = 0
              }
            } else if (
              player.getStatus() === 'ready' ||
              player.getStatus() === 'loading' ||
              player.getStatus() === 'init'
            ) {
              that.isPlay = 4
            } else {
              that.currentTime = currentTimeTemp
              that.progress = progressTemp
              that.isPlay = 0
              that.isAdd = true
            }
            /* eslint-disable */
            if (that.player._el == null) {
              clearInterval(that.timeOut)
              that.progress = 0
              that.currentTime = 0
            }
            /* eslint-enable */
          }, 1000)
        }
      )
      setTimeout(() => {
        if (that.progress < 98) {
          that.player.seek(that.playTime)
        }
      }, 2500)
    },

    // 上一章视频
    preVideo () {
      if (this.is_click_preVideo) {
        return false;
      }
      this.is_click_preVideo = true;
      setTimeout(() => {
        this.is_click_preVideo = false;
      }, 1000);
      if (this.index > 0) {
        this.isPlay === 4

        this.index = this.index - 1
        this.PlayCourse(this.index)
      } else {
        this.$message.warning('没有上一章视频了')
      }
    },
    // 下一章视频
    nextVideo () {
      if (this.is_click_nextVideo) {
        return false;
      }
      this.is_click_nextVideo = true;
      setTimeout(() => {
        this.is_click_nextVideo = false;
      }, 1000);
      if (this.index < this.courseGoodsList.length - 1) {
        this.isPlay === 4

        this.index = this.index + 1
        this.PlayCourse(this.index)
      } else {
        this.$message.warning('没有下一章视频了')
      }
    },

    getVideoToken (kzwVideoNo) {
      console.log('kzwVideoNo', kzwVideoNo)
      // 获取该课程信息
      let data = {
        nos: kzwVideoNo,
        skipHead: 1
      }
      // 获取menu数据
      COURSE_GOOD_API.videoToken(data)
        .then(res => {
          if (Number(res.code) === 0) {
            this.videoToken = res.data[0].videoToken
            setTimeout(() => {
              this.videoPlay(this.videoToken)
            }, 500)
          } else {
            this.catalogData = {}
            this.courseGoodsList = []
            this.$message.error('获取播放授权失败')
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 初始化阔知网视频播放器
    videoPlay (token) {
      let that = this
      // 测试 service-cdn.cg-dev.cn
      // service-cdn.qiqiuyun.net
      load(
        '//service-cdn.qiqiuyun.net/js-sdk-v2/sdk-v1.js?' +
        ~~(Date.now() / 1000 / 60),
        err => {
          if (err) {
            throw err
          }
          /* eslint-disable no-new */
          that.player = new window.QiQiuYun.Player({
            id: 'cloud-player',
            // 用于初始化的DOM节点ID
            resNo: that.resNo,
            // 播放资源编号
            token: token,
            // 设置是否跳转至上次观看位置继续
            rememberLastPos: true,
            playbackRates: [0.5, 1, 1.5, 2.0],
            // 封面图
            // poster: that.goodsThumb,
            initPos: that.playTime,
            skip: that.isHeader,
            // 播放令牌由后端SDK生成
            // playServer: 'play.qiqiuyun.net',
            // 关于水印的相关参数
            watermark: {
              file: that.logoUrl,
              pos: 'top.right',
              width: '40px'
            }
          })
            .on('timeupdate', function (event) {
              console.log(event, '我在播放')
              var totalTime = event.duration
              var currentTime = event.currentTime
              var progress = 0
              currentTime = parseInt(currentTime)
              progress = (currentTime / totalTime).toFixed(2)
              that.currentTime = currentTime
              that.progress = progress
              that.isPlay = 0
              that.isAdd = true
            })
            .on('ready', function (event) {
              console.log(event, '我在准备中')
              that.isPlay = 4
            })
            .on('paused', function (event) {
              console.log(event, '我暂停播放')
              that.isPlay = 1
              that.AddLearnlod()
            })
            .on('ended', function (event) {
              console.log(event, '我播放结束')
              that.isPlay = 3
              that.AddLearnlod()
            })
        }
      )
    },
    initPlayer () {
      if (Number(this.videoSourceType) === 0) {
        //初始化阔知网视频播放器
        this.resNo = this.currentGoodsEntity.kzwVideoNo
        this.isHeader = this.currentGoodsEntity.isHeader
        this.waterMarkId = this.currentGoodsEntity.waterMarkId
        //阔知网初始化播放器
        this.getVideoToken(this.resNo)
      } else {
        //初始化阿里云播放器
        let url = this.currentGoodsEntity.goodsVideo
        // 获取最后一个.的位置
        var index = url.lastIndexOf('.')
        // 获取后缀
        var ext = url.substr(index + 1)
        if (ext === 'flv') {
          this.videoSourceType = 2
          setTimeout(() => {
            this.xiguaPlay(url)
          }, 500)
        } else {
          setTimeout(() => {
            this.aliPlayer(url)
          }, 500)
        }
      }
    },
    xiguaPlay (url) {
      var that = this
      this.player = new window.FlvJsPlayer({
        id: 'mse',
        url: url,
        height: '11.625rem',
        // poster: that.goodsThumb,
        width: window.innerWidth
      });
      // play	播放
      // playing	继续播放
      // pause	暂停
      // ended	结束
      this.player.on('play', function () {
        console.log('play')
        that.isPlay = 0
        that.AddLearnlod()
        //事件名称可以在上述查询
      })
      this.player.on('playing', function (event) {
        console.log('playing')
        console.log(event)
        var totalTime = event.duration
        var currentTime = event.currentTime
        var progress = 0
        currentTime = parseInt(currentTime)
        progress = (currentTime / totalTime).toFixed(2)
        that.currentTime = currentTime
        that.progress = progress
        that.isPlay = 0
        that.isAdd = true
        //事件名称可以在上述查询
      })
      this.player.on('pause', function () {
        console.log('pause')
        that.isPlay = 1
        that.AddLearnlod()
        //事件名称可以在上述查询
      })
      this.player.on('ended', function () {
        console.log('ended')
        that.isPlay = 3
        that.AddLearnlod()
        //事件名称可以在上述查询
      })
    },
    toVideoPlay (t) {
      console.log(888, t)
    },

    backToCourse () {
      if (sessionStorage.getItem('isChannel')) {
        this.$router.push({
          path: '/h5/CourseDetail',
          query: {
            token: localStorage.getItem('shangke_token'),
            c_no: localStorage.getItem('c_no'),
            cat_id: localStorage.getItem('cat_id'),
            show_header: localStorage.getItem('show_header'),
            show_data: localStorage.getItem('show_data')
          }
        })
      } else {
        this.$router.push('/h5/CourseDetail')
      }
    },
  },
}
</script>
<style lang="less" scoped>
.container {
  background: #ffffff;
}
.video {
  background: rgb(246, 247, 248);
}
.bottom-btn {
  padding: 10px 17px;
  display: flex;
  background: #ffffff;
  width: 100%;
  justify-content: space-between;
  bottom: 0;
  .btn-item {
    padding: 0 13px;
    width: 165px;
    height: 39px;
    background: rgba(249, 249, 249, 1);
    border-radius: 4px;
    line-height: 39px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    &:hover {
      background: rgba(225, 240, 255, 1);
      color: rgba(77, 167, 249, 1);
    }
  }
}
/deep/ .van-tabs__wrap {
  &.van-hairline--top-bottom {
    &::after {
      border-width: 0px 0;
    }
  }
}
// 折叠背景置灰
/deep/ .van-collapse-item__content {
  background-color: #f9f9f9;
  padding: 0 16px;
}
// tab下滚动条样式
/deep/ .van-tabs__line {
  width: 20px !important;
  background: linear-gradient(
    161deg,
    rgba(74, 199, 255, 1) 0%,
    rgba(77, 167, 249, 1) 100%
  );
}
.item-box {
  background-color: #ffffff;
  overflow: hidden;
  padding: 10px 16px;
  .item-info {
    font-size: 12px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(106, 106, 106, 0.81);
    line-height: 18px;
  }
  .item-intro {
    margin-top: 10px;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(106, 106, 106, 0.81);
    line-height: 24px;
  }
}
.item-des {
  margin-top: 10px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 18px;
}
.channel-info {
  height: 39px;
  background: #4da7f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 14px;
  .channel-img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    vertical-align: middle;
  }
  .channel-name {
    margin-left: 10px;
    vertical-align: middle;
  }
}

.prism-player {
  width: 100%;
  height: 180px;
}

.introduce {
  border-bottom: 8px solid #F5F5F5;
  padding: 16px 15px 21px;
  .item-des {
    flex: 1;
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    font-weight: bold;
    color: #333333;
  }
  &_rate {
    min-width: 111px;
    margin-left: 10px;
  }
  .item-info {
    font-size: 14px;
    font-weight: 500;
    color: #666666;
    margin-top: 11px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .classCount {
      width: 76px;
      height: 26px;
      background: #F5F5F5;
      border-radius: 13px;
      line-height: 26px;
      text-align: center;
    }
  }
}
</style>
